import(/* webpackMode: "eager" */ "/app/apps/PublicUI/pages/404.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/PublicUI/public/404-owl.png");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
